import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import { FlexCenterWrapper, ActionHeaderWrapper, Mr2, Ml8, UnderlineDecoration } from 'wrappers';
import { ClickableIcon, Text, ClickableSecondaryTextSm } from 'atoms';
import { CheckboxSvg } from 'components/icons';
import { OutlinedButton } from 'molecules';

export const definition = {
  name: 'OrdersActionTableHeader',
  controller: Controller,
  initialProps: ({ selectedOrdersCount, selectedTab, selectedOrdersList, orders   }) => 
  ({ selectedOrdersCount, selectedTab,selectedOrdersList, orders}),
  props: internalState,
  elements: [
    {
      wrapper: FlexCenterWrapper,
      name: 'Checkbox',
      elements: [
        {
          component: wrap(ClickableIcon, Mr2),
          name: 'Checkbox',
          renderIf: ({ selectedOrdersList, orders })=> selectedOrdersList?.map((order) => order.id)?.some(id => orders?.map(o=>o.id)?.includes(id)),
          displayValue: ({}) => CheckboxSvg({ indeterminate:true }),
          bindings: ({ }) => ({})
        },
        {
          component: wrap(ClickableIcon, Mr2),
          name: 'Checkbox',
          renderIf: ({ selectedOrdersList, orders })=> !selectedOrdersList?.map((order) => order.id)?.some(id => orders?.map(o=>o.id)?.includes(id)),
          displayValue: () => CheckboxSvg({ checked: false }),
          bindings: ({ }) => ({})
        },
        {
          component: Text,
          name: 'Count',
          displayValue: ({ selectedOrdersCount }) => `${selectedOrdersCount} Selected`,
          bindings: () => ({})
        },
        {
          component: wrap(wrap(ClickableSecondaryTextSm, UnderlineDecoration), Ml8),
          name: 'Button',
          displayValue: ({  }) => `Unselect All`,
          bindings: () => ({})
        }
      ]
    },
    {
      wrapper: FlexCenterWrapper,
      name: 'Buttons',
      elements: [
        {
          component: wrap(OutlinedButton, Mr2),
          name: 'AssignToTech',
          renderIf: ({ selectedTab }) => selectedTab === 'unassigned',
          bindings: ({ selectedOrdersList }) => ({ title: 'Assign to technician', selectedOrdersList })
        },
        {
          component: wrap(OutlinedButton, Mr2),
          name: 'AssignToVendor',
          renderIf: ({ selectedTab }) => selectedTab === 'unassigned',
          bindings: ({ selectedOrdersList }) => ({ title: 'Assign to vendor', selectedOrdersList })
        },
        {
          component: wrap(OutlinedButton, Mr2),
          name: 'UnassignOrders',
          renderIf: ({ selectedTab }) => selectedTab === 'assigned',
          bindings: ({ selectedOrdersList }) => ({ title: 'Unassign Orders', selectedOrdersList })
        },
        {
          component: wrap(OutlinedButton, Mr2),
          name: 'CancelOrders',
          displayValue: () => null,
          renderIf: ({ selectedTab }) => selectedTab === 'assigned' || selectedTab === 'unassigned',
          bindings: ({ }) => ({ title: 'Cancel Orders' })
        },
        {
          component: wrap(OutlinedButton, Mr2),
          name: 'ReopenOrders',
          displayValue: () => null,
          renderIf: ({ selectedTab }) => selectedTab === 'completed',
          bindings: ({ }) => ({ title: 'Reopen Orders' })
        },
        {
          component: wrap(OutlinedButton, Mr2),
          name: 'ReopenOrders',
          displayValue: () => null,
          renderIf: ({ selectedTab }) => selectedTab === 'cancelled',
          bindings: ({ }) => ({ title: 'Reopen Orders' })
        }
      ]
    },
  ]
};

export default wrap(ContainerComponent(definition), ActionHeaderWrapper);